export default __webpack_public_path__ + "static/media/peopleAround.f13ca03a.wav";